// API
import { api } from './api';

/**
 * Special fetch method for GET leads for views list by sending query parameters
 *
 * @param params LeadsCallQueryParamsType
 * @param headers
 * @returns
 */
export default async function fetchLeadItem(leadId: string = '', token: string) {
    const url = [api.leadItem, leadId].join('/');
    const resp = await fetch(url, {
        method: 'GET',
        headers: {
            'Accept-Language': 'de-DE',
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
        },
    });

    return {
        data: resp.status === 200 ? resp.json() : undefined,
        status: resp.status,
        error: resp.status === 200 ? undefined : resp,
    };
}
